import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { adminApi } from '../../lib/api';
import { pillSecondary } from '../ui/pills';
import { DroitsUsagePage } from './DroitsUsagePage';
import { MesModulesPage } from './MesModulesPage';

/** Vue super-admin (maquette L01-10) : même grille « Mes modules », pour un client précis, et ses droits d'usage. */
export const AdminOrganisationPage: React.FC = () => {
    const { id = '' } = useParams();
    const [nom, setNom] = useState('');
    useEffect(() => {
        let vivant = true;
        adminApi.getClient(id).then((c: any) => { if (vivant) setNom(c?.company_name || c?.name || ''); }).catch(() => {});
        return () => { vivant = false; };
    }, [id]);

    const bandeau = (
        <div role="note" className="flex flex-wrap items-center gap-3 rounded-xl bg-state-info-soft text-state-info px-4 py-3 text-[13px]">
            <Eye size={16} className="shrink-0" />
            <p className="flex-1 min-w-0">Vous voyez le compte <b>{nom || id}</b> en tant que Directeur.</p>
            <Link to={`/admin/clients/${id}`} className={`${pillSecondary(32)} text-content`}>Quitter</Link>
        </div>
    );

    return (
        <div className="space-y-8">
            <MesModulesPage clientId={id} bandeau={bandeau} />
            <DroitsUsagePage clientId={id} sansEntete />
        </div>
    );
};

export default AdminOrganisationPage;
